// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".feature-flag-wrapper[data-v-3f6495a0]{max-width:100%;flex:0 0 100%}.manual-btn-wrapper[data-v-3f6495a0]{margin-top:-32px;margin-bottom:12px;display:flex;justify-content:flex-end;width:100%;padding:12px}.manual-btn[data-v-3f6495a0]{cursor:pointer;display:flex;align-items:center;gap:4px;z-index:9}", ""]);
// Exports
module.exports = exports;
